<script lang="ts">
	import PickupIcon from '~/icons/Routes/house.svelte';
	import DropoffIcon from '~/icons/Routes/office.svelte';
	import SwapIcon from '~/icons/Routes/swap.svelte';
	import SwapSVG from '~/icons/shuffle.svelte';
	import { humanizeURL } from '~/utils/utils';
	import { generateSrcset } from '~/utils/images';

	export let data: RouteExplorationCard;
	export let fromApp: boolean = false;
	export let page: string;
	export let small: boolean = false;

	let morningShift = true;
	let infoByShift: RouteInfoByShift;
	let returnRouteTime: string;
	let routeLink: string = '';
	let kebabCaseRouteName: string;
	let srcset: any;

	$: infoByShift = morningShift ? data.morning : data.evening;
	$: {
		routeLink = humanizeURL(
			`/route/${infoByShift.pickup.name} ${infoByShift.dropoff.name}/${fromApp ? '?source=app' : ''}`
		);
		kebabCaseRouteName = humanizeURL(`${infoByShift.pickup.name} ${infoByShift.dropoff.name}`);
	}
	$: returnRouteTime = !morningShift ? 'morning' : 'evening';
	$: {
			// srcset = generateSrcset(`/tmp/route-map-${infoByShift.id}.jpg`);
	}

	function swapShift() {
		morningShift = !morningShift;
	}
</script>


<a id={`${kebabCaseRouteName}-${page}`} class="rounded-[1rem] bg-complementary-grey2 ce-200 hover:scale-95 ease-in-out duration-300 nav-in inline-block" href={routeLink}>
	<figure class="contents bg-complementary-grey2">
		<div class="ce-200 rounded-[1rem] p-3 pb-6 bg-neutral-0 grid grid-rows-[auto_auto] gap-6">
			<div class="rounded-lg md:rounded-[10px] overflow-hidden">
				<!-- <picture>
					<source srcset={srcset.avif} type="image/avif"/>
					<source srcset={srcset.webp} type="image/webp"/>
					<img 
						class="w-full"
						loading="lazy"
						src={srcset.jpg.src}
						width={srcset.jpg.width}
						style="aspect-ratio: 64/41;"
						alt={`${infoByShift.pickup.name} - ${infoByShift.dropoff.name} route map`}/>
				</picture> -->
					<img 
						class="w-full"
						loading="lazy"
						src={`/tmp/route-map-${infoByShift.id}.jpg`}
						width={320}
						style="aspect-ratio: 64/41;"
						alt={`${infoByShift.pickup.name} - ${infoByShift.dropoff.name} route map`}/>
			</div>
			<div class="grid gap-2 border-l-2 border-neutral-100 border-dashed ml-2">
				<div class="grid gap-x-2 sm:gap-x-4 relative">
					<div class="grid -translate-x-[0.3rem] absolute">
						<span class="block w-2 h-2 bg-neutral-0" />
						<span class="block aspect-square w-[8px] rounded-full bg-accent" />
					</div>
					<div class="text-neutral-900 pl-4">
						<p class="grid gap-1 sm:gap-[8px] grid-cols-[16px_auto] items-center">
							{#if morningShift}
								<PickupIcon class="w-4 sm:w-[20px]" />
							{:else}
								<DropoffIcon class="w-4 sm:w-[20px]" />
							{/if}
							<span
								class:sm:text-[16px]={!small}
								class="text-neutral-400 text-xs sm:text-[16px] font-normal"
							>
								Pickup Area
							</span>
						</p>
						<p class:sm:text-[20px]={!small} class="text-md font-medium">
							{infoByShift.pickup.name}
						</p>
					</div>
				</div>
				<div class="relative">
					<hr />
					<button aria-label="Swap location to check {returnRouteTime} route" id={`${kebabCaseRouteName}-swap-shift`} class="absolute -translate-y-1/2 right-0 click bg-complementary-grey rounded-full p-2" on:click|stopPropagation|preventDefault={swapShift}>
						<!-- <SwapIcon class="h-6 w-6 sm:h-8 sm:w-8 pointer-events-none"/> -->
						<SwapSVG class="w-4 h-4  pointer-events-none" />
					</button>
					<p
						class="absolute right-0 translate-y-[20px] sm:translate-y-[24px] text-[10px] sm:text[12px] text-primary-100 font-normal w-[35%] text-right"
					>
						Swap location to check {returnRouteTime} route
					</p>
				</div>
				<div class="grid gap-x-2 sm:gap-x-4 relative">
					<div class="grid grid-rows-[0.5rem_1fr] -translate-x-[0.3rem] translate-y-5 absolute h-full">
						<span class="block aspect-square w-[8px] rounded-full bg-primary" />
						<span class="block w-2 h-50 bg-neutral-0" />
					</div>
					<div class="text-neutral-900 pl-4">
						<p class="grid gap-1 sm:gap-[8px] grid-cols-[16px_auto] items-center">
							{#if !morningShift}
								<PickupIcon class="w-4 sm:w-[20px]" />
							{:else}
								<DropoffIcon class="w-4 sm:w-[20px]" />
							{/if}
							<span class:sm:text-[16px]={!small} class="text-neutral-400 text-xs font-normal">
								Dropoff Area
							</span>
						</p>
						<p class:sm:text-[20px]={!small} class="text-md font-medium">{infoByShift.dropoff.name}</p>
					</div>
				</div>
			</div>
		</div>
		<figcaption class="px-3 py-2 text-sm text-center text-primary-200">
			{@html `Buses every ${infoByShift.frequency} minutes between <time datetime="${infoByShift.first_bus_time}">${infoByShift.first_bus_time}</time> - <time datetime="${infoByShift.last_bus_time}">${infoByShift.last_bus_time}</time>`}
		</figcaption>
	</figure>
</a>
